import React from "react";
import Upload from "./Upload";
function uploadPhotos () {
    return (
        <>
        <Upload/>
        </>
    )
}
export default uploadPhotos;